

<!-- Hero Banner Section -->
<div class="blog-hero-banner">
  <div class="hero-content">
    <p class="hero-subtitle">DISCOVER SEHYOG INSIGHTS</p>
    <h1 class="hero-title">EXPLORE OUR LATEST ARTICLES</h1>
    <p class="hero-description">
      Stay updated with the latest educational insights, success stories, and expert guidance 
      to help students achieve their academic goals.
    </p>
    <button class="hero-btn" (click)="scrollToBlogs()">Read Articles →</button>
  </div>
  <div class="hero-image">
    <img [src]="featuredBlog?.image || '/assets/images/default-hero.jpg'" 
         [alt]="featuredBlog?.title || 'Featured Blog'" />
  </div>
</div>

<!-- All Blogs Section -->
<div class="blogs-main">
  <div class="all-blog-cont">
    
    <!-- Section Header -->
    <div class="section-header">
      <!-- <h2>Latest Articles</h2>
      <a class="see-all-link">
        See All <span class="arrow">→</span>
      </a> -->
    </div>

    <div *ngIf="blogs.length > 0; else noBlogs">
      
      <!-- Blog Grid -->
      <div class="blog-grid" id="calendar-section">
        <div
          *ngFor="let blog of blogs"
          class="blog-card"
          (click)="openBlog(blog)"
        >
          <div class="blog-card-image">
            <img [src]="blog.image" [alt]="blog.title" />
            <span class="blog-category" *ngIf="blog.category">{{ blog.category }}</span>
          </div>
          
          <div class="blog-card-content">
            <div class="blog-meta">
              <span class="blog-date">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M11.667 2.333H2.333C1.597 2.333 1 2.93 1 3.667v9.333c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V3.667c0-.737-.597-1.334-1.333-1.334zM11.667 13H2.333V5.667h9.334V13z" fill="currentColor"/>
                </svg>
                {{ blog.publishedDate | date: 'dd MMM yyyy' }}
              </span>
              <span class="blog-author" *ngIf="blog.author">{{ blog.author }}</span>
            </div>
            
            <h3 class="blog-card-title">{{ blog.title }}</h3>
            
            <p class="blog-card-snippet" *ngIf="blog.snippet">
              {{ blog.snippet }}
            </p>
          </div>
        </div>
      </div>

    </div>

    <ng-template #noBlogs>
      <div class="no-blogs">
        <p>No blog posts found.</p>
      </div>
    </ng-template>

  </div>
</div>



